import React, { useCallback, useMemo } from "react";
import PropTypes from "prop-types";
import { useLocation, useHistory } from "react-router-dom";
import { withAreaGetter } from "../../providers/AreasConsumers";
import menuConfig from "constants/menuConfig";
import { useTranslation } from "react-i18next";
import Portal from "../../utils/portal/Portal";
import { IconButton } from "@totalsoft/rocket-ui";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { areas } from "../../constants/areas";
import { HeaderTitleContainer } from "./LayoutStyles";
import useLocator from "hooks/useLocator";

const HeaderPortal = ({ getElemByAreaKey, partner, children, inEdit, customTitle }) => {
  const { t } = useTranslation();
  const { isBank, path } = useLocator();
  const location = useLocation();
  const history = useHistory();


  const makeBrand = useCallback(pathname => {
    const menu = menuConfig.find(menu => pathname.indexOf(menu.path) !== -1);
    return menu ? menu.name : "";
  }, []);

  const pageTitle = useMemo(() => {
    if (customTitle) {
      return customTitle;
    }
    const pathName = makeBrand(location.pathname);
    const partnerNameTitle = partner?.partnerName || "";
    return !partnerNameTitle
      ? t(`NavBar.${pathName}`)
      : isBank
        ? t("Bank.PageTitle", { data: partnerNameTitle })
        : t("Partner.PageTitle", { data: partnerNameTitle });
  }, [location.pathname, isBank, partner, t, makeBrand, customTitle]);

  return (
    <Portal container={getElemByAreaKey(areas.header)}>
      <HeaderTitleContainer id={"header_title"}>
        {pageTitle}
        <div>
          {inEdit ? (
            <IconButton
              color="primary"
              variant="text"
              tooltip={t("Tooltips.BackToList")}
              onClick={() => history.push(`/${path}`)}
            >
              <ArrowBackIcon />
            </IconButton>
          ) : (
            ""
          )}
          <div>{children} </div>
        </div>
      </HeaderTitleContainer>
    </Portal>
  );
};

HeaderPortal.propTypes = {
  getElemByAreaKey: PropTypes.func.isRequired,
  partner: PropTypes.object,
  children: PropTypes.object,
  inEdit: PropTypes.bool,
  customTitle: PropTypes.string
};

export default withAreaGetter(HeaderPortal);
